var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32_497)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48135 5.60002C6.63633 5.60002 5.86259 6.07523 5.65494 6.97332L5.6549 6.97349C5.39964 8.07597 6.08925 9.08237 6.85072 9.81732C7.20406 10.1466 7.75395 10.1457 8.09895 9.81794C8.86694 9.08407 9.55789 8.07662 9.30249 6.97349L9.30208 6.97171C9.09731 6.07488 8.32626 5.60002 7.48135 5.60002ZM10.4718 6.70371C10.1166 5.1503 8.76296 4.40002 7.48135 4.40002C6.19964 4.40002 4.8449 5.15018 4.48582 6.70282M10.4718 6.70371C10.8815 8.47571 9.74564 9.90437 8.92733 10.6862L8.92639 10.687C8.11054 11.4631 6.83504 11.4487 6.02672 10.6897L6.021 10.6843L6.02103 10.6843C5.21127 9.90372 4.07566 8.47474 4.48578 6.70299"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7012 14.1C15.8475 14.1 15.0704 14.5773 14.8633 15.4733L14.8633 15.4734C14.608 16.5759 15.2982 17.5831 16.0714 18.3157C16.4249 18.6467 16.9834 18.6462 17.3289 18.3176L17.3299 18.3166C18.1036 17.584 18.7945 16.5763 18.5392 15.4734L18.5391 15.4733C18.332 14.5773 17.5549 14.1 16.7012 14.1ZM19.7083 15.2028C19.3487 13.6481 17.9866 12.9 16.7012 12.9C15.4158 12.9 14.0537 13.6481 13.6942 15.2028M19.7083 15.2029C20.1187 16.976 18.982 18.4049 18.155 19.188C17.3391 19.9631 16.0573 19.9484 15.2492 19.1897L15.2474 19.188C14.4203 18.4048 13.2838 16.976 13.6941 15.203"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5042 7.12209C11.5042 6.79072 11.7728 6.52209 12.1042 6.52209H14.0025C15.8681 6.52209 16.7328 8.83096 15.3333 10.0593L9.673 15.0112L9.67189 15.0122C9.10649 15.5043 9.4563 16.4388 10.2059 16.4388H12.1042C12.4356 16.4388 12.7042 16.7074 12.7042 17.0388C12.7042 17.3702 12.4356 17.6388 12.1042 17.6388H10.2059C8.34901 17.6388 7.48048 15.3297 8.88335 14.1076V14.1076L14.5417 9.1574V9.1574C15.111 8.65735 14.7578 7.72209 14.0025 7.72209H12.1042C11.7728 7.72209 11.5042 7.45347 11.5042 7.12209Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.89014 7.47628C6.89014 7.14491 7.15877 6.87628 7.49014 6.87628H7.49832C7.82969 6.87628 8.09832 7.14491 8.09832 7.47628C8.09832 7.80765 7.82969 8.07628 7.49832 8.07628H7.49014C7.15877 8.07628 6.89014 7.80765 6.89014 7.47628Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0985 15.9763C16.0985 15.6449 16.3671 15.3763 16.6985 15.3763H16.7067C17.0381 15.3763 17.3067 15.6449 17.3067 15.9763C17.3067 16.3077 17.0381 16.5763 16.7067 16.5763H16.6985C16.3671 16.5763 16.0985 16.3077 16.0985 15.9763Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32_497"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtm);
export default __webpack_public_path__ + "static/media/utm.437b77f2.svg";
export { ForwardRef as ReactComponent };